import React from 'react';
import styles from './Quiz.module.css';
import { motion, AnimatePresence } from 'motion/react';
import Question from '../Question/Question';
import { ClassicQuiz, QuestionImgQuiz } from './DifferentQuizzes';

const Quiz = ({
  variants,
  title,
  questionImgUrl,
  currentState,
  questionFontSize,
  marginTopQuiz,
  idVote,
  delayTransition,
}) => {
  const isLong = title?.length > 115;

  const getCurrentTypeQuize = () => {
    if (questionImgUrl) {
      return 'questionImg';
    } else return 'classic';
  };

  const quizComponents = {
    classic: ClassicQuiz,
    questionImg: QuestionImgQuiz,
  };

  const isStateCorrectVar = ['S3'].includes(currentState);
  const CurrentQuiz = quizComponents[getCurrentTypeQuize()];

  return (
    <div
      className={styles.container}
      style={{ marginTop: `${Number(marginTopQuiz)}rem` }}
    >
      <Question
        delayTransition={delayTransition}
        title={title}
        questionImgUrl={questionImgUrl}
        isLong={isLong}
        questionFontSize={questionFontSize}
      />

      <AnimatePresence mode="wait">
        <motion.div
          className={styles.containerQuiz}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7 }}
          key={idVote}
        >
          {CurrentQuiz && (
            <CurrentQuiz
              delayTransition={delayTransition}
              variants={variants}
              isStateCorrectVar={isStateCorrectVar}
              questionImgUrl={questionImgUrl}
            />
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default React.memo(Quiz);
